module.exports = __webpack_public_path__ + "img/volume-up-solid.b135c13d.svg";